export const TEMPO_TAGGED_REVIEWS = 'tempo_tagged_reviews';
export const HUB_REDIRECT = 'hub_redirect';
export const NEW_PAUSED_NO_SUBSCRIPTION = 'new_paused_no_subscription';
export const DORMANT_PAUSED_NO_SUBSCRIPTION = 'dormant_paused_no_subscription';
export const TEMPO_IDME_OFFER2 = 'tempo_idme_offer2';
export const EXPRESSPLUS_SATURATION_DYNAMIC = 'expressplus_saturation_dynamic';
export const EXPRESSPLUS_SATURATION_STATIC = 'expressplus_saturation_static';
export const REORDERED_FUNNEL_CORE = 'reordered_funnel_core';
export const REORDERED_FUNNEL_FAMILY = 'reordered_funnel_family';
export const REORDERED_FUNNEL_TEMPO = 'reordered_funnel_tempo';
export const TEMPO_HNE_ON_CORE = 'tempo_hne_on_core';
